<script>
import MessagePreview from 'dashboard/components/widgets/conversation/MessagePreview.vue';
import { MESSAGE_TYPE } from 'shared/constants/messages';
import AILoader from 'dashboard/components/widgets/AILoader.vue';

// composables
import { useAI } from 'dashboard/composables/useAI';

export default {
  name: 'Transcription',
  components: {
    MessagePreview,
    AILoader,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
    audioUrl: {
      type: String,
      required: true,
    },
    fileType: {
      type: String,
      default: 'audio',
    },
  },
  setup() {
    const { getAudioTranscript, getFileTranscript } = useAI();
    return { getAudioTranscript, getFileTranscript };
  },
  data() {
    return {
      MESSAGE_TYPE,
      transcription: {},
      isGenerating: false,
    };
  },
  mounted() {
    if (this.message.additional_attributes?.file_transcript) {
      this.transcription.content =
        this.message.additional_attributes.file_transcript;
    } else if (this.fileType === 'audio' && this.message.content) {
      this.transcription.content = this.message.content;
    }

    if (this.fileType === 'audio') {
      this.getTranscription(this.audioUrl, this.message.id);
    } else if (!this.message.additional_attributes?.file_transcript) {
      this.getFileAnalysis(this.audioUrl, this.message.id);
    }
  },
  methods: {
    async getTranscription(url, messageId) {
      this.isGenerating = true;
      try {
        const result = await this.getAudioTranscript(url, messageId);
        this.transcription.content = result || '';
      } catch (e) {
        this.transcription.content = '';
      } finally {
        this.isGenerating = false;
      }
    },
    async getFileAnalysis(url, messageId) {
      this.isGenerating = true;
      try {
        const result = await this.getFileTranscript(url, messageId);
        this.transcription.content = result || '';
      } catch (e) {
        this.transcription.content = '';
      } finally {
        this.isGenerating = false;
      }
    },
  },
};
</script>

<template>
  <div
    class="px-2 py-1.5 rounded-md min-w-[10rem] mb-2 bg-slate-50 dark:bg-slate-800 dark:text-slate-50 message-text--metadata"
  >
    <AILoader v-if="isGenerating" />
    <MessagePreview
      v-else
      class="transcription"
      :message="transcription"
      :show-message-type="false"
      default-empty-message="Transcrição indisponível"
    />
  </div>
</template>

<style lang="scss" scoped>
.txt-transcription {
  font-size: 10px !important;
}
.transcription {
  white-space: pre-line !important;
  font-style: italic !important;
}
</style>
